import { render } from "./SmartRecords.vue?vue&type=template&id=8e9c0ab0"
import script from "./SmartRecords.vue?vue&type=script&lang=js"
export * from "./SmartRecords.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__